import { useMemo } from 'react'

import { useOpenLogModal } from '../../../../../utils/routes/modals/modalsActions'

export const useRowsActions = (item, ids) => {
  const openDetailsModal = useOpenLogModal()

  const singleOptions = useMemo(
    () => [
      {
        value: 'seeDetails',
        icon: 'BsSearch',
        onClick: () => openDetailsModal(item)
      }
    ],
    [item, openDetailsModal]
  )

  return [singleOptions, false]
}
